export default __webpack_public_path__ + "static/media/logo.b7c4b0c1.jpg";